import { DataStorage } from '@wegic/common';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { collect } from '@/modules/Collect/helper';

/**
 * 页面浏览追踪 Hook
 * 监听路由变化并发送页面浏览埋点
 */
export function usePageViewTracker() {
  const location = useLocation();
  const pathname = location.pathname.split('/')[1] || '';

  useEffect(() => {
    const source = DataStorage.getField('source');
    const plan = DataStorage.getField('plan');

    collect('page_view_wegicai', {
      object: pathname,
      source,
      plan,
    });
  }, [location.pathname]);
}
